import checker from '@/sui/tools/checker'
import rezo from '@/components/sheets/import/impl/rezo'
import microOrgs from '@/sui/data/microOrgs'

function createPatient () {
  return {
    codetab: 1,
    codserv: 22,
    idsej: 154,
    fiche: 12,
    dnais: '10/07/1982',
    dentree: '02/01/2019',
    dsortie: '05/01/2019',
    etatsort: 1,
    sexe: 1,
    atbadm: 1,
    trauma: 1,
    catediag: 1,
    provpat: 1,
    idep: 1,
    igsII: 22,
    typebmrsarm: 2,
    typebmrgisa: 2,
    typebmrerg: 2,
    typebmreblse: 2,
    typebmrepc: 2,
    typebmrabri: 2,
    typebmrparc: 2,
    ecmo: 2,
    intub: 2,
    cvc: 1,
    infection: 1,
    infrespi: 2,
    imc: 20.3
  }
}

function createCVC () {
  return {
    codetab: 1,
    codserv: 22,
    fiche: 1,
    numcvc: 1,
    typecvc: 1,
    sitecvc: 1,
    debutcvc: '02/01/2019',
    fincvc: '05/01/2019',
    labo: 1,
    colinf: 1
  }
}

function createBacteriemia () {
  return {
    numero: 1,
    codetab: 1,
    codserv: 22,
    fiche: 1,
    numinf: 1,
    datein: '02/01/2019',
    sitein: 2,
    mo1in: 'STAAUR',
    pein: 9
  }
}

function createPneumopathy () {
  return {
    numero: 1,
    codetab: 1,
    codserv: 22,
    fiche: 1,
    numinf: 1,
    datein: '02/01/2019',
    sitein: 2,
    mo1in: 'STAAUR',
    cdpin: 1
  }
}

function checkNumericFields (c, p, t, l, f) {
  for (let i = 0; i !== l; ++i) {
    t.forEach(
      (test) => { p[test.in] = i }
    )
    const v = f(p)
    t.forEach(
      (test) => {
        const expected = test.g.indexOf(i) === -1 ? test.n : i
        const got = v[test.out]
        c.check(
          expected === got,
          `${test.in} (${test.out}): expected ${expected}, got ${got}`
        )
      }
    )
  }
}

function checkDates (c, p, t, f) {
  const dates = [
    { str: '02/03/1945', date: new Date(1945, 2, 2, 10) },
    { str: '12/03/1995', date: new Date(1995, 2, 12, 10) },
    { str: '01/12/2045', date: new Date(2045, 11, 1, 10) }
  ]

  dates.forEach(
    (d) => {
      t.forEach((test) => { p[test.in] = d.str })
      const v = f(p)
      t.forEach(
        (test) => {
          const value = v[test.out]
          c.check(
            d.date.getTime() === value.getTime(),
            `{test.in} (${test.out}): expected ${d.date}, got ${value}`
          )
        }
      )
    }
  )
}

function checkSheetNumber (c) {
  const p = createPatient()
  p.codserv = 20
  for (let i = 0; i !== 10; ++i) {
    p.fiche = i
    const r = rezo.createPatient(p)
    const expected = p.codserv * 1000 + i
    c.check(
      r.sheetNumber === expected,
      `sheetNumber: expected ${expected}, got ${r.sheetNumber}`)
  }
}

function checkPatientNumericFields (c) {
  const p = createPatient()
  const tests = [
    { in: 'sexe', out: 'sex', g: [1, 2], n: 9 },
    { in: 'trauma', out: 'trauma', g: [1, 2], n: 9 },
    { in: 'catediag', out: 'diagnosis', g: [1, 2, 3], n: 9 },
    { in: 'idep', out: 'immuno', g: [1, 2, 3], n: 9 },
    { in: 'atbadm', out: 'antibio', g: [1, 2], n: 9 },
    { in: 'ecmo', out: 'ecmo', g: [1, 2, 3], n: 9 },
    { in: 'intub', out: 'intubated', g: [1, 2], n: 9 },
    { in: 'reint', out: 'reintubated', g: [1, 2], n: 9 },
    { in: 'etatsort', out: 'dead', g: [1, 2], n: 9 }
  ]
  checkNumericFields(c, p, tests, 10, rezo.createPatient)
}

function checkDeathAndExitDate (c) {
  const p = createPatient()

  {
    p.etatsort = 1
    checkDates(c, p, [{ in: 'dsortie', out: 'death' }], rezo.createPatient)
    const v = rezo.createPatient(p)
    c.check(
      v.exit == null,
      `etatsort == 1: expected null exit date (${v.exit})`
    )
  }

  for (let i in [2, 9]) {
    p.etatsort = i
    checkDates(c, p, [{ in: 'dsortie', out: 'exit' }], rezo.createPatient)
    const v = rezo.createPatient(p)
    c.check(
      v.death == null,
      `etatsort == ${i}: expected null death date (${v.death})`
    )
  }
}

function checkPatientDates (c) {
  const p = createPatient()

  const tests = [
    { in: 'dnais', out: 'birthdate' },
    { in: 'dentree', out: 'entry' },
    { in: 'debutintub', out: 'intubStart' },
    { in: 'finintub', out: 'intubEnd' },
    { in: 'debutsad', out: 'urinaryStart' },
    { in: 'finsad', out: 'urinaryEnd' }
  ]
  checkDates(c, p, tests, rezo.createPatient)
}

function checkOrigin (c) {
  const p = createPatient()
  const tests = [
    { name: 'domicile', in: 1, out: 1 },
    { name: 'EHPAD/EMS', in: 2, out: 7 },
    { name: 'SLD', in: 3, out: 6 },
    { name: 'SSR', in: 4, out: 4 },
    { name: 'Court séjour', in: 5, out: 3 },
    { name: 'Réanimation', in: 6, out: 2 }
  ]
  tests.forEach(
    (t) => {
      p.provpat = t.in
      const v = rezo.createPatient(p)
      c.check(
        t.out === v.origin,
        `origin ${t.in}(${t.name}): expected ${t.out}, got ${v.origin}`
      )
    }
  )
}

function checkCovid (c) {
  const p = createPatient()
  const tests = [
    { name: 'aucun', infrespi: 2, virus: null, out: 3 },
    { name: 'virus', infrespi: 1, virus: 'VIRCOV', out: 2 },
    { name: 'inf', infrespi: 1, virus: 'VIRINF', out: 3 },
    { name: 'vrs', infrespi: 1, virus: 'VIRVRS', out: 3 },
    { name: 'autre', infrespi: 1, virus: 'VIRAUT', out: 3 }
  ]
  for (let i = 0; i !== tests.length; ++i) {
    const t = tests[i]
    p.infrespi = t.infrespi
    p.virus = t.virus
    const v = rezo.createPatient(p)
    c.check(
      t.out === v.covidStatus,
      `covid ${t.infrespi} + ${t.virus} (${t.name}): expected ${t.out}, got ${v.covidStatus}`
    )
  }
}

function checkPortage (c) {
  const p = createPatient()
  const list = [
    'epc', 'erg', 'sarm', 'eblse', 'gisa', 'abri', 'parc'
  ]
  list.forEach(
    (l) => { p[`typebmr${l}`] = 1 }
  )
  const expected = [
    { p: 1, m: [6, 3, 1, 5, 2, 7, 8] },
    { p: 1, m: [3, 1, 5, 2, 7, 8] },
    { p: 1, m: [1, 5, 2, 7, 8] },
    { p: 1, m: [5, 2, 7, 8] },
    { p: 1, m: [2, 7, 8] },
    { p: 1, m: [7, 8] },
    { p: 1, m: [8] },
    { p: 2, m: null, n: 9 },
    { p: 2, m: null }, { p: 2, m: null }, { p: 2, m: null }, { p: 2, m: null },
    { p: 2, m: null }, { p: 2, m: null }, { p: 9, m: null, n: 1 },
    { p: 1, m: [6] },
    { p: 1, m: [6, 3] },
    { p: 1, m: [6, 3, 1] },
    { p: 1, m: [6, 3, 1, 5] },
    { p: 1, m: [6, 3, 1, 5, 2] },
    { p: 1, m: [6, 3, 1, 5, 2, 7] },
    { p: 1, m: [6, 3, 1, 5, 2, 7, 8] }
  ]
  let i = 0
  let n = 2
  expected.forEach(
    (e) => {
      const v = rezo.createPatient(p)
      c.check(
        v.portageBmrBhre === e.p,
        `portageBmrBhre: expected ${e.p}, got ${v.portageBmrBhre}`
      )
      c.check(
        checkBmrBhreMicroOrgs(v.bmrBhreMicroOrgs, e.m),
        `bmrBhreMicroOrg: expected ${e.m}, got ${v.bmrBhreMicroOrgs}`
      )
      if (e.n != null) {
        n = e.n
      }
      const l = list[i]
      p[`typebmr${l}`] = n
      if (++i === list.length) {
        i = 0
      }
    }
  )
}

function checkBmrBhreMicroOrgs (v, e) {
  if (v.length === 0 && e === null) {
    return true
  }
  if (v.length !== e.length) {
    return false
  }
  for (let i = 0; i < v.length; i++) {
    if (v[i].code !== e[i]) {
      return false
    }
  }
  return true
}

function checkFloatFields (c, patientSheetFct, tests, f) {
  for (let i = 0; i < tests.length; i++) {
    const t = tests[i]
    const values = t.values

    for (let j = 0; j < values.length; j++) {
      const sh = patientSheetFct()
      const v = values[j]
      sh.imc = v.in

      const r = f(sh)
      c.check(
        v.out === r.bmi,
        `${t.in} (${t.out}): expected ${v.out} for ${v.in}, got ${r.bmi}`
      )
    }
  }
}

function checkBmi (c) {
  const tests = [
    {
      in: 'imc',
      out: 'bmi',
      values: [
        { in: 0, out: 999 },
        { in: 0.999, out: 999 },
        { in: 1, out: 1 },
        { in: 10.4, out: 10 },
        { in: 50.2, out: 50 },
        { in: 97.7, out: 98 },
        { in: 98.9, out: 98 },
        { in: 98.91, out: 999 },
        { in: 99.9, out: 999 },
        { in: 105, out: 999 }
      ]
    }
  ]
  checkFloatFields(c, createPatient, tests, rezo.createPatient)
}

function checkPatient (c) {
  checkSheetNumber(c)
  checkPatientNumericFields(c)
  checkDeathAndExitDate(c)
  checkPatientDates(c)
  checkOrigin(c)
  checkCovid(c)
  checkPortage(c)
  checkBmi(c)
}

function checkCVCNumericFields (c) {
  const cvc = createCVC()

  const tests = [
    { in: 'central', out: 'central', g: [], n: 1 },
    { in: 'labo', out: 'laboratory', g: [1, 2], n: null },
    { in: 'colinf', out: 'isColIlcBlc', g: [0, 1, 2, 3, 4], n: 9 }
  ]
  checkNumericFields(c, cvc, tests, 10, rezo.createCVC)
}

function checkCVCDates (c) {
  const cvc = createCVC()

  const tests = [
    { in: 'debutcvc', out: 'insertion' },
    { in: 'datecolinf', out: 'colIlcBlc' }
  ]
  checkDates(c, cvc, tests, rezo.createCVC)
}

function checkCVCRemoved (c) {
  const cvc = createCVC()
  const tests = [
    { values: [1, 2], expected: 1, date: true },
    { values: [9], expected: 9 },
    { values: [0, 3, 4, 5, 12, 122], expected: 2 }
  ]
  const dateTests = [{ in: 'fincvc', out: 'removal' }]
  tests.forEach(
    (t) => {
      t.values.forEach(
        (value) => {
          cvc.labo = value
          const v = rezo.createCVC(cvc)
          c.check(
            v.removed === t.expected,
            `removed (from labo): expected ${t.expected}, got ${v.removed}`
          )
          if (t.date) {
            checkDates(c, cvc, dateTests, rezo.createCVC)
          } else {
            c.check(
              v.removal == null,
              `removal (from labo): expected null date with labo ${value}`
            )
          }
        }
      )
    }
  )
}

function checkMicroOrgs (c, target, suffix, f, g, viruses) {
  const tests = [
    {
      microOrgs: ['STAAUR', 'KLEPNE'],
      oxa: [0, 1],
      gly: [1, 9],
      c3g: [0, 1],
      car: ['', null],
      caz: [null, null],
      epc: [null, null],
      blse: [null, 1],
      flu: [0, 1],
      epcType: [null, null],
      ppc: [null, null],
      expected: [
        {
          code: 'STA AUR',
          antibio: { oxa: 0, c3g: 0, gly: 2, pan: 3, flu: 0 }
        },
        {
          code: 'KLE PNE',
          antibio: { oxa: 2, gly: 3, c3g: 2, pan: 3, flu: 1, blse: 0 }
        }
      ]
    },
    {
      microOrgs: ['ESCCOL', 'FILAUT'],
      oxa: [9, 2],
      gly: [0, 3],
      c3g: [2, 3],
      car: [0, 1],
      caz: [null, null],
      epc: [null, null],
      blse: [null, null],
      flu: [2, 3],
      epcType: [null, null],
      ppc: [null, null],
      expected: [
        {
          code: 'ESC COL',
          antibio: { oxa: 3, gly: 0, car: 0, c3g: 3, pan: 3, flu: 2 }
        },
        {
          code: 'FIL AUT',
          antibio: { oxa: 3, gly: 3, c3g: 3, car: 2, flu: 2 }
        }
      ]
    },
    {
      microOrgs: ['PSEAER', 'CITKOS'],
      oxa: [null, null],
      gly: [null, null],
      flu: [null, null],
      c3g: [null, 0],
      caz: [3, null],
      car: [1, 1],
      epc: [null, 1],
      blse: [null, null],
      epcType: [null, null],
      ppc: [null, null],
      expected: [
        {
          code: 'PSE AER',
          antibio: { caz: 3, car: 2, pan: 3, ppc: 2 }
        },
        {
          code: 'CIT KOS',
          antibio: { c3g: 0, car: 2, pan: 3, epc: 0, epcType: 9 }
        }
      ]
    },
    {
      microOrgs: ['PSEAER', 'CITKOS'],
      oxa: [null, null],
      gly: [null, null],
      flu: [null, null],
      c3g: [null, 0],
      caz: [3, null],
      car: [1, 1],
      epc: [null, 0],
      blse: [null, null],
      epcType: [null, null],
      ppc: [null, null],
      expected: [
        {
          code: 'PSE AER',
          antibio: { caz: 3, car: 2, pan: 3, ppc: 2 }
        },
        {
          code: 'CIT KOS',
          antibio: { c3g: 0, car: 2, pan: 3, epc: 1 }
        }
      ]
    }
  ]
  if (viruses) {
    tests.push(
      {
        microOrgs: ['VIRVRS', 'NONIDE'],
        oxa: [2, 3],
        gly: [0, null],
        c3g: [2, 3],
        car: [0, 1],
        flu: [2, 3],
        caz: [null, null],
        epc: [null, null],
        blse: [null, null],
        epcType: [null, null],
        ppc: [null, null],
        expected: [
          {
            code: 'VIR VRS',
            antibio: { gly: 0, oxa: 3, c3g: 3, car: 0, flu: 2 }
          },
          {
            code: 'NON IDE',
            antibio: { oxa: 3, c3g: 3, car: 2, flu: 2 }
          }
        ]
      }
    )
  } else {
    tests.push(
      {
        microOrgs: ['VIRVRS', 'NONEFF'],
        oxa: [2, 3],
        gly: [0, 3],
        c3g: [2, 3],
        car: [0, 1],
        flu: [2, 3],
        caz: [null, null],
        epc: [null, null],
        blse: [null, null],
        epcType: [null, null],
        ppc: [null, null],
        expected: [{ code: null }, { code: null }]
      }
    )
  }
  const list = [ 'oxa', 'gly', 'c3g', 'car', 'flu', 'caz', 'epc', 'blse', 'epcType', 'ppc' ]
  tests.forEach(
    (t) => {
      for (let i = 1; i !== 3; i++) {
        const field = `mo${i}${suffix}`
        target[field] = t.microOrgs[i - 1]
        list.forEach((r) => {
          target[`${r}${i}`] = t[r][i - 1]
        })
      }

      const v = f(target)
      for (let i = 0; i !== 2; ++i) {
        const e = t.expected[i]
        const micro = v[g][i]
        if (e.code == null) {
          c.check(
            micro == null,
            `micro (${t.microOrgs[i]}): expected undefined micro, got ${micro}`
          )
          continue
        }
        const code = microOrgs.completeList.v1.find(m => e.code === m.code).index
        c.check(
          micro.code === code,
          `micro.code: expected ${code} (${e.code}), got ${micro.code}`
        )
        const la = []
        micro.antibio.forEach(
          (a) => {
            const field = microOrgs.resistances.v2.find(r => r.index === a.code)
            la.push(field.field)
            const prefix = `m[${t.microOrgs[i]}]antibio.resistance[${field.field}]`
            c.check(
              e.antibio[field.field] === a.resistance,
              `${prefix}: expected ${e.antibio[field.field]}, got ${a.resistance}`
            )
          }
        )
        for (let k in e.antibio) {
          if (la.find(r => r === k) == null) {
            const prefix = `m[${t.microOrgs[i]}]antibio.resistance[${k}]`
            c.check(
              false,
              `${prefix}: expected ${e.antibio[k]}, got undefined`
            )
          }
        }
      }
    }
  )
}

function checkCVCMicroOrgs (c) {
  const cvc = createCVC()
  checkMicroOrgs(c, cvc, 'colinf', rezo.createCVC, 'microOrganisms', false)
}

function checkCVCType (c) {
  const cvc = createCVC()
  const expected = [
    { in: 1, out: 'C1' },
    { in: 2, out: 'D1' },
    { in: 3, out: 'C4' },
    { in: 4, out: 'C8' }
  ]
  expected.forEach(
    (t) => {
      cvc.typecvc = t.in
      const v = rezo.createCVC(cvc)
      c.check(
        t.out === v.type_v2,
        `CVC type ${t.in}: expected ${t.out}, got ${v.type_v2}`
      )
    }
  )
}

function checkCVCInsertionSite (c) {
  const cvc = createCVC()
  const expected = [
    { in: 1, out: 1 },
    { in: 2, out: 2 },
    { in: 3, out: 3 },
    { in: 4, out: 7 },
    { in: 5, out: 10 }
  ]

  expected.forEach(
    (t) => {
      cvc.sitecvc = t.in
      const v = rezo.createCVC(cvc)
      c.check(
        t.out === v.insertionSite,
        `CVC insertionSite ${t.in}: expected ${t.out}, got ${v.insertionSite}`
      )
    }
  )
}

function checkCVC (c) {
  checkCVCNumericFields(c)
  checkCVCInsertionSite(c)
  checkCVCDates(c)
  checkCVCRemoved(c)
  checkCVCMicroOrgs(c)
  checkCVCType(c)
}

function checkEntrance (c) {
  const bact = createBacteriemia()
  const tests = [
    { in: 1, out: 'C13' }, { in: 2, out: 'C5' }, { in: 3, out: 'C1' },
    { in: 4, out: 'C4' }, { in: 5, out: 'D1' }, { in: 6, out: 'C2' },
    { in: 7, out: 'C6' }, { in: 8, out: 'C12' }, { in: 9, out: 'C7' },
    { in: 10, out: 'A3' }, { in: 11, out: 'A4' }, { in: 12, out: 'A5' },
    { in: 13, out: 'A10' }, { in: 14, out: 'A1' }, { in: 99, out: 'A13' }
  ]
  const additional = [
    {
      f: e => e != null && e < 10,
      v: [{ c: 'insertionSite', v: 10 }, { c: 'removed', v: 9 }]
    },
    { f: e => e != null && e === 24, v: [{ c: 'catheter', v: 9 }] }
  ]
  tests.forEach(
    (t) => {
      bact.pein = t.in
      const v = rezo.createBacteriemia(bact)
      c.check(
        v.entrance_v2 === t.out,
        `entrance (${t.in}): expected ${t.out}, got ${v.entrance_v2}`
      )
      additional.forEach(
        (a) => {
          if (!a.f(v.entrance_v2)) {
            return
          }
          a.v.forEach(
            (u) => {
              c.check(
                v[u.c] === u.v,
                `${u.c} (${v.entrance_v2}): expected ${u.v}, got ${v[u.c]}`
              )
            }
          )
        }
      )
    }
  )
}

function checkBacteremia (c) {
  const bact = createBacteriemia()

  {
    const tests = [
      { in: 'present', out: 'present', g: [], n: 1 }
    ]
    checkNumericFields(c, bact, tests, 10, rezo.createBacteriemia)
  }

  {
    const tests = [
      { in: 'datein', out: 'episod' }
    ]
    checkDates(c, bact, tests, rezo.createBacteriemia)
  }
  checkMicroOrgs(c, bact, 'in', rezo.createBacteriemia, 'microOrganisms', false)
  checkEntrance(c)
}

function checkPneumopathy (c) {
  const bact = createPneumopathy()
  {
    const tests = [
      { in: 'pneumopathy', out: 'pneumopathy', g: [], n: 1 },
      { in: 'cdpin', out: 'diagnosis', g: [1, 2, 3, 4, 5], n: 9 }
    ]
    checkNumericFields(c, bact, tests, 10, rezo.createPneumopathy)
  }

  {
    const tests = [
      { in: 'datein', out: 'episod' }
    ]
    checkDates(c, bact, tests, rezo.createPneumopathy)
  }
  checkMicroOrgs(c, bact, 'in', rezo.createPneumopathy, 'microOrganisms', true)
}

function check () {
  const c = checker()

  checkPatient(c)
  checkCVC(c)
  checkBacteremia(c)
  checkPneumopathy(c)

  c.end()
}

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'
const exported = debug ? check : function () {}
export default exported
